// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import { HEALTH_GOOD_DEAL_PLAN } from 'client/constants/optimizelyFeatureFlag';
import { getMedicaidMembers } from 'client/utils/health/applicant';
import { getRecommendationParamsFromApp } from 'client/utils/health/recommendation';
import { postPlan, putApp } from 'client/actions/ifpApps';
import CORE_PRODUCT_TYPES from 'client/constants/productTypes';
import withEnrollmentPeriodsHook from 'client/hooks/enrollmentPeriod/withEnrollmentPeriodsHook';
import withPlanRecommendationHook from 'client/hooks/health/plan/withPlanRecommendationHook';
import { STRIDE } from 'client/constants/globals';
import EdeCartDataLoader from 'routes/cart/components/edeCartDataLoader';

import { getCartPropsFromState } from 'routes/cart/util';
import { getPartnerDisplayName } from 'routes/health/utils';

const mapStateToProps: Object = (state) => {
  const isGoodDealPlanEnabled = _.get(state.optimizely, HEALTH_GOOD_DEAL_PLAN, false);
  const {
    activeAppTypes,
    cartApps,
    cartAppTypes,
    checkoutRoute,
    dentalApp,
    hasFFMApp,
    healthApp,
    isHealthCareGov,
    premiumTotal,
    visionApp,
  } = getCartPropsFromState(state);
  const medicaidMembers = getMedicaidMembers(_.get(healthApp, 'members', []));
  const shouldDisplayMedicaidWarning = medicaidMembers.length > 0;
  /*
   * Only cross sell when we have a Health (Non-FFM) app or
   * user does not already have a Dental or Vision app that is active
   * or already in the cart
   */
  const cartAndActiveAppsTypeMap = _.reduce(
    [...cartAppTypes, ...activeAppTypes],
    (acc, type) => ({ ...acc, [type]: true }),
    {},
  );
  const allowCrossSell = _.get(state, 'siteConfigs.brandSiteConfig.partnerConfig.allowCrossSell');
  const displayCrossSell =
    !hasFFMApp &&
    (!cartAndActiveAppsTypeMap[CORE_PRODUCT_TYPES.DENTAL] ||
      !cartAndActiveAppsTypeMap[CORE_PRODUCT_TYPES.VISION]);
  const shouldDisplayCrossSell =
    allowCrossSell === undefined ? displayCrossSell : allowCrossSell && displayCrossSell;
  const hasDentalOrVisionInCart = dentalApp || visionApp;

  /*
   * Get query string parameter values for fetching
   * enrollment periods (withEnrollmentPeriodsHook)
   */
  const withEnrollmentPeriodsHookProps = {
    address: _.get(cartApps[0], 'address', {}),
    onExchange: _.get(healthApp, 'app_json.plan.onExchange', false),
    /*
     * Cart apps are sorted in following order ['health', 'dental', 'vision']
     * Will fetch enrollment periods based on first product in cart
     */
    productType: cartAppTypes[0],
  };
  /*
   * If healthapp is added to cart, we will get details for fetching recommendations.
   * Otherwise, query will be skipped when calling withPlanRecommendationHook HOC
   */
  const withPlanRecommendationHookProps = healthApp
    ? { ...getRecommendationParamsFromApp(healthApp), isGoodDealPlanEnabled }
    : {};

  const partnerDisplayName = getPartnerDisplayName(state);
  const partnerName = _.get(state, 'siteConfigs.brandSiteConfig.name', STRIDE);
  const ichraContribution = state.user.ichra ? state.user.ichra.contribution : null;

  return {
    contentfulData: state.contentfulData,
    personId: state.personId,
    phase3Enabled: state.phase3Enabled,
    cartApps,
    checkoutRoute,
    hasDentalOrVisionInCart,
    hasFFMApp,
    healthApp,
    isHealthCareGov,
    premiumTotal,
    shouldDisplayCrossSell,
    shouldDisplayMedicaidWarning,
    partnerDisplayName,
    partnerName,
    ...withEnrollmentPeriodsHookProps,
    ...withPlanRecommendationHookProps,
    ichraContribution,
    allowGaAccess: state.allowGaAccess,
    siteConfigs: state.siteConfigs,
  };
};

export default connect(mapStateToProps, { postPlan, putApp })(
  withEnrollmentPeriodsHook(withPlanRecommendationHook(EdeCartDataLoader)),
);
